import _flatten from 'lodash/flatten';
export const ImagePlaceholders = [
    { imageCode: 'simple_01', imageId: '', src: '' },
    { imageCode: 'simple_02', imageId: '', src: '' },
    { imageCode: 'simple_03', imageId: '', src: '' },
    { imageCode: 'simple_04', imageId: '', src: '' },
    { imageCode: 'simple_05', imageId: '', src: '' },
    { imageCode: 'simple_06', imageId: '', src: '' },
    { imageCode: 'simple_07', imageId: '', src: '' },
    { imageCode: 'simple_08', imageId: '', src: '' },
    { imageCode: 'simple_09', imageId: '', src: '' },
    { imageCode: 'simple_10', imageId: '', src: '' },
    { imageCode: 'simple_11', imageId: '', src: '' },
    { imageCode: 'simple_12', imageId: '', src: '' },
    { imageCode: 'simple_13', imageId: '', src: '' },
    { imageCode: 'simple_14', imageId: '', src: '' },
    { imageCode: 'simple_15', imageId: '', src: '' },
    { imageCode: 'simple_16', imageId: '', src: '' },
    { imageCode: 'simple_17', imageId: '', src: '' },
    { imageCode: 'simple_18', imageId: '', src: '' },
    { imageCode: 'simple_19', imageId: '', src: '' },
    { imageCode: 'simple_20', imageId: '', src: '' },
    { imageCode: 'simple_21', imageId: '', src: '' },
    { imageCode: 'simple_22', imageId: '', src: '' },
    { imageCode: 'simple_23', imageId: '', src: '' },
    { imageCode: 'simple_24', imageId: '', src: '' },
    { imageCode: 'simple_25', imageId: '', src: '' },
    { imageCode: 'simple_26', imageId: '', src: '' },
    { imageCode: 'simple_27', imageId: '', src: '' },
    { imageCode: 'simple_28', imageId: '', src: '' },
    { imageCode: 'simple_29', imageId: '', src: '' },
    { imageCode: 'simple_30', imageId: '', src: '' }
];
export const AdminImagePlaceholders = [
    { imageCode: 'ext_f_main', imageId: '', src: '' },
    { imageCode: 'ext_f_left', imageId: '', src: '' },
    { imageCode: 'ext_l_main', imageId: '', src: '' },
    { imageCode: 'ext_b_left', imageId: '', src: '' },
    { imageCode: 'ext_b_main', imageId: '', src: '' },
    { imageCode: 'ext_b_right', imageId: '', src: '' },
    { imageCode: 'ext_r_main', imageId: '', src: '' },
    { imageCode: 'ext_f_right', imageId: '', src: '' },
    { imageCode: 'ext_f_main_opened', imageId: '', src: '' },
    { imageCode: 'ext_f_left_opened', imageId: '', src: '' },
    { imageCode: 'ext_l_main_opened', imageId: '', src: '' },
    { imageCode: 'ext_b_left_opened', imageId: '', src: '' },
    { imageCode: 'ext_b_main_opened', imageId: '', src: '' },
    { imageCode: 'ext_b_right_opened', imageId: '', src: '' },
    { imageCode: 'ext_r_main_opened', imageId: '', src: '' },
    { imageCode: 'ext_f_right_opened', imageId: '', src: '' },
    { imageCode: 'conext_f_main', imageId: '', src: '' },
    { imageCode: 'conext_f_left', imageId: '', src: '' },
    { imageCode: 'conext_l_main', imageId: '', src: '' },
    { imageCode: 'conext_b_left', imageId: '', src: '' },
    { imageCode: 'conext_b_main', imageId: '', src: '' },
    { imageCode: 'conext_b_right', imageId: '', src: '' },
    { imageCode: 'conext_r_main', imageId: '', src: '' },
    { imageCode: 'ext_feat_engine', imageId: '', src: '' },
    { imageCode: 'int_f_ipanel1', imageId: '', src: '' },
    { imageCode: 'int_f_ipanel2', imageId: '', src: '' },
    { imageCode: 'int_f_ipanel5', imageId: '', src: '' },
    { imageCode: 'int_f_driverseats', imageId: '', src: '' },
    { imageCode: 'int_f_assistantseats', imageId: '', src: '' },
    { imageCode: 'int_b_rearseats', imageId: '', src: '' },
    { imageCode: 'int_f_fandrseats', imageId: '', src: '' },
    { imageCode: 'int_f_driverdashboard', imageId: '', src: '' },
    { imageCode: 'int_f_doordriverside', imageId: '', src: '' },
    { imageCode: 'int_f_stickshift', imageId: '', src: '' },
    { imageCode: 'int_b_trunk', imageId: '', src: '' },
    { imageCode: 'int_t_sunroof', imageId: '', src: '' },
    { imageCode: 'int_t_panorama_sunroof', imageId: '', src: '' },
    { imageCode: 'int_f_ipanel3', imageId: '', src: '' },
    { imageCode: 'int_f_ipanel4', imageId: '', src: '' },
    { imageCode: 'ext_feat_rims', imageId: '', src: '' },
    { imageCode: 'int_feat_bluetooth', imageId: '', src: '' },
    { imageCode: 'int_feat_handsfree', imageId: '', src: '' },
    { imageCode: 'int_feat_headupdisplay', imageId: '', src: '' },
    { imageCode: 'int_feat_breakassistant', imageId: '', src: '' },
    { imageCode: 'ext_feat_parkassistant', imageId: '', src: '' },
    { imageCode: 'ext_feat_auxiliaryheating', imageId: '', src: '' },
    { imageCode: 'int_feat_startstop', imageId: '', src: '' },
    { imageCode: 'ext_feat_trafficsignrec', imageId: '', src: '' },
    { imageCode: 'int_feat_seatheating', imageId: '', src: '' },
    { imageCode: 'ext_feat_cruisecontrol', imageId: '', src: '' },
    { imageCode: 'int_feat_climatization', imageId: '', src: '' },
    { imageCode: 'ext_feat_lightsensor', imageId: '', src: '' },
    { imageCode: 'ext_feat_ledlights', imageId: '', src: '' },
    { imageCode: 'ext_feat_laneassistant', imageId: '', src: '' },
    { imageCode: 'ext_feat_nightassistant', imageId: '', src: '' },
    { imageCode: 'ext_feat_rainsensor', imageId: '', src: '' }
];
export const exteriorImageCodesOrder = [
    [
        'ext_f_main',
        'ext_f_left',
        'ext_l_main',
        'ext_b_left',
        'ext_b_main',
        'ext_b_right',
        'ext_r_main',
        'ext_f_right'
    ],
    [
        'ext_f_main_opened',
        'ext_f_left_opened',
        'ext_l_main_opened',
        'ext_b_left_opened',
        'ext_b_main_opened',
        'ext_b_right_opened',
        'ext_r_main_opened',
        'ext_f_right_opened'
    ],
    [
        'conext_f_main',
        'conext_f_left',
        'conext_l_main',
        'conext_b_left',
        'conext_b_main',
        'conext_b_right',
        'conext_r_main',
        'conext_f_right'
    ]
].map(imagesCodes => imagesCodes.reduce((map, imageCode, order) => map.set(imageCode, order), new Map()));
export const exteriorImageCodes = new Set(_flatten(exteriorImageCodesOrder.map(codesOrder => [...codesOrder.keys()])));
